import { Box, Stack, Text, Title } from "@mantine/core";
import { useOutletContext } from "react-router-dom";
import type { PrivateContext } from "@/components/layout/PrivateLayout";
import { hasScope } from "@/lib/auth";
import { EmptyState } from "@/components/common/EmptyState";

export default function PrivateAssets() {
  const { session } = useOutletContext<PrivateContext>();

  if (!hasScope(session, "raw-assets")) {
    return (
      <EmptyState
        title="Out of scope"
        body="Your token doesn't include `raw-assets`."
      />
    );
  }

  return (
    <Stack gap="lg">
      <Box>
        <Title order={1}>Raw assets</Title>
        <Text c="dimmed" mt="xs">
          Hi-res photo, raw video, artwork originals. Signed download links live here.
        </Text>
      </Box>
      <EmptyState
        title="No assets surfaced yet"
        body="Raw originals upload to R2 under private/* and will appear here once paths are populated."
      />
    </Stack>
  );
}
